import { Link } from "react-router-dom"
import blogImg from '../../assets/images/blog-img-1.png'

const Blog = () => {
    return (
        <div className="blog-area pt-100">
            <div className="container">
                <div className="section-title">
                    <span className="top-title">Our Blog</span>
                    <h2>Latest News &amp; Updates</h2>
                </div>
                <div className="row justify-content-center">
                    {Array(3).fill().map((i, index) => (
                        <div className="col-lg-4 col-sm-6 col-md-6">
                            <div className="single-blog-card">
                                <div className="blog-img">
                                    <Link to="/blog-detail">
                                        <img src={blogImg} alt="images" />
                                    </Link>
                                </div>
                                <ul>
                                    <li><i className="flaticon-calendar"></i>August 0{index + 3},2022</li>
                                    <li><i className="flaticon-comment"></i>0{index} Comment</li>
                                </ul>
                                <Link to="/blog-detail">
                                    <h3>Overcame Breeding Point Concerns Has Terminate</h3>
                                </Link>
                                <Link to="/blog-detail" className="learn-more">Learn More <i className="flaticon-next"></i></Link>
                            </div>
                        </div>
                    ))}
                </div>
                {window.location.pathname !== '/blogs' &&
                    <div className="view-all-btn">
                        <Link to="/blogs" className="default-btn btn-style-one">View All</Link>
                    </div>}
            </div>
        </div>
    )
}

export default Blog